import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';

/**
 * Lets an invited co-host into a webinar's studio on the HOST's plan
 * (co-host follow, phase 5).
 *
 * PrivateRoute renders this only for someone its plan wall would otherwise
 * send to /pricing. It asks the server whether they are a live co-host of
 * this studio's webinar whose host's plan is active
 * (GET /webinars/:id/studio-role → role 'cohost' + hostPlanActive). Anything
 * else, including a failed or slow lookup, shows `fallback` (the same
 * /pricing redirect as before), so nobody gets in who was refused before
 * except a co-host the server vouches for.
 */
export function coHostStudioAllowed(data) {
  return !!data && data.role === 'cohost' && data.hostPlanActive === true;
}

const CoHostStudioGate = ({ children, fallback, loading = null }) => {
  const { sessionId } = useParams();
  const [state, setState] = useState('checking'); // 'checking' | 'allowed' | 'denied'

  useEffect(() => {
    if (!sessionId) {
      setState('denied');
      return undefined;
    }
    let cancelled = false;
    setState('checking');
    api.get(`/webinars/${encodeURIComponent(sessionId)}/studio-role`, { timeout: 8000, suppressGlobalError: true })
      .then((res) => { if (!cancelled) setState(coHostStudioAllowed(res.data) ? 'allowed' : 'denied'); })
      .catch(() => { if (!cancelled) setState('denied'); });
    return () => { cancelled = true; };
  }, [sessionId]);

  if (state === 'checking') return loading;
  return state === 'allowed' ? children : fallback;
};

export default CoHostStudioGate;
